import { render, staticRenderFns } from "./LearningSettingsReminderCreate.vue?vue&type=template&id=6dcd878b&scoped=true&"
import script from "./LearningSettingsReminderCreate.vue?vue&type=script&lang=js&"
export * from "./LearningSettingsReminderCreate.vue?vue&type=script&lang=js&"
import style0 from "./LearningSettingsReminderCreate.vue?vue&type=style&index=0&id=6dcd878b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcd878b",
  null
  
)

export default component.exports